import Document from '@tiptap/extension-document'
import { detectMob } from '@/core/helper-functions'

export const Chat = Document.extend({
  addKeyboardShortcuts () {
    return {
      Enter: () => {
        const isMobile = detectMob()
        if (!isMobile && typeof this.options.enterHandler === 'function') return this.options.enterHandler()
      }
    }
  }
})
